import styled, { css } from 'styled-components';
import { MButtonType, MButtonSize } from './MButton.types';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers } = baseVariables;

export const createStyledButton = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  component: any
) => styled(component)<{
  variant: MButtonType;
  size: MButtonSize;
}>`
  ${({ variant, size }) =>
    variant === MButtonType.Tertiary
      ? css`
          background-color: transparent;
          &.disabled {
            color: #c4c4c4;
          }

          /* DUX-1153 Global Styles overrides:  body [class*='m-link-tertiary-button'], body [class*='m-link-tertiary-button-external'] */
          &.m-link-tertiary-button,
          &.m-link-tertiary-button-external {
            display: inline-flex;
            border-bottom: 0;
            gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
            align-items: center;
            justify-content: center;
            line-height: 2rem;
            margin-inline: 0;
            padding: 0;
            &::before,
            &::after {
              content: '';
              display: none;
            }
            &:hover,
            &:focus {
              border-bottom: 0;
            }
            &.disabled {
              pointer-events: none;
            }
            &:not(.disabled) {
              &:hover,
              &:focus {
                .btn-label {
                  text-decoration: underline;
                }
              }
            }
          }
        `
      : css`
          /* DUX-1153 Global Styles overrides:  body [class*='m-button'] */
          &[class*='m-button'] {
            padding-inline: ${size === MButtonSize.L
              ? spacers?.spacers?.[4] ?? '1.5rem'
              : spacers?.spacers?.[3] ?? '1rem'};
            padding-block: 0;
            display: inline-flex;
            gap: ${spacers?.spacers?.[1] ?? '0.25rem'};
            align-items: center;
            justify-content: center;
            &.disabled {
              &:focus {
                outline: 0;
              }
            }
          }
          &.icon-leading {
            padding-inline-start: ${size === MButtonSize.L ? 1.25 : 0.75}rem;
          }
          &.icon-trailing {
            padding-inline-end: ${size === MButtonSize.L ? 1.25 : 0.75}rem;
          }
        `}
`;

export const MButtonLabel = styled.span`
  line-height: inherit;
  display: inline-block;
`;
